import { useQuery } from '@tanstack/react-query';
import { CustomerDocExt } from 'khufu-legos';

import { getCustomers } from '../../../apis/queries';
import { GET_CUSTOMERS_KEY } from '../../Customers/Customers';
import ReturnEmpties from './ReturnEmpties';

interface CustomerOption {
  _id: string;
  name: string;
}

const CreateReturnEmpties = () => {
  const { data, isLoading } = useQuery({ queryKey: GET_CUSTOMERS_KEY, queryFn: () => getCustomers({ limit: 10000 }) });

  const customers: CustomerOption[] | undefined = data?.results?.map((customer: CustomerDocExt) => ({
    _id: customer._id.toString(),
    name: customer.name
  }));

  return (
    <>
      <ReturnEmpties customers={customers} initialLoading={isLoading} />
    </>
  );
};

export default CreateReturnEmpties;
